<div class="panel rs-bg-grey1">
  <h3 class="rs-tit6 rs-txt-c1">{{ 'mpay.threshold.title' | translate }}</h3>
  <px-alert
    *ngIf="missingThresholdInfo"
    [alerts]="[
      {
        type: 'warning',
        description: 'mpay.threshold.fetch.error' | translate,
        isClosable: false
      }
    ]"
  ></px-alert>
  <form (ngSubmit)="updateMPayThreshold()" *ngIf="!missingThresholdInfo">
    <div
      *ngIf="!isPending"
      class="rs-form-item"
      [ngClass]="{
        error: threshold?.invalid,
        'rs-form-success': threshold?.valid
      }"
    >
      <div class="rs-flex-row rs-flex-middle">
        <div class="rs-flex-columns small-11 medium-4">
          <input
            type="number"
            id="notificationA"
            name="notificationA"
            aria-describedby="ac-error1"
            [formControl]="threshold"
          />
          <label
            class="rs-form-label"
            [ngClass]="{ error: threshold?.invalid }"
            for="notificationA"
            >{{ thresholdPlaceHolder }}</label
          >
        </div>
        <div class="rs-flex-columns small-1 medium-8">€</div>
      </div>
      <span *ngIf="threshold?.invalid" class="error" id="ac-error1">{{ thresholdRangeError }}</span>
    </div>
    <div class="rs-flex-row" *ngIf="isPending">
      <div class="rs-flex-columns">
        <span class="rs-label rs-padding-top1">{{ 'mpay.threshold.select' | translate }}</span>
      </div>
      <div class="rs-flex-columns rs-flex-grow">
        <p *ngIf="isPending" class="rs-txt-pt3">
          {{ 'mpay.threshold.pending' | translate }}
        </p>
      </div>
    </div>
    <div class="rs-flex-row rs-flex-middle" *ngIf="!isPending">
      <div class="rs-flex-columns">
        <button
          *ngIf="!isThresholdUpdating"
          type="submit"
          href="#"
          class="rs-btn rs-btn-large rs-no-margin-top"
          [disabled]="threshold?.invalid || threshold?.pristine || isFormDisabled"
        >
          {{ 'mpay.threshold.save' | translate }}
        </button>
        <span *ngIf="isThresholdUpdating" class="rs-spinner"></span>
      </div>

      <div class="rs-flex-columns">
        <p>
          <a [attr.aria-disabled]="isFormDisabled" href="javascript:void(0)" (click)="cancel()">{{
            'mpay.threshold.cancel' | translate
          }}</a>
        </p>
      </div>
    </div>
  </form>
  <div class="rs-accordion-panel jsrs-accordion-panel clearfix">
    <a
      href="javascript:void(0)"
      class="rs-accordion-title rs-no-padding-h rs-no-padding-top"
      aria-expanded="false"
      aria-controls="accordion3"
      data-accordion-panel-trigger=""
    >
      <span class="rs-accordion-more">{{ 'mpay.threshold.mandates.show' | translate }}</span>
      <span class="rs-accordion-less">{{ 'mpay.threshold.mandates.hide' | translate }}</span>
      <span class="show-for-small rs-txt-c1 rs-txt-hover rs-txt-s3">{{
        'mpay.threshold.mandates.active' | translate
      }}</span>
      <i class="icon-Arrow-down icon-lh rs-accordion-arrow"></i>
    </a>
    <div class="rs-accordion-content rs-no-padding hide" data-accordion-panel-content="">
      <px-alert
        *ngIf="hasError"
        [alerts]="[
          {
            type: 'warning',
            description: 'mpay.threshold.mandates.fetch' | translate,
            isClosable: false
          }
        ]"
      ></px-alert>
      <ng-container *ngIf="!hasError">
        <p *ngIf="!hasActiveMandates()">
          {{ 'mpay.threshold.mandates.empty' | translate }}
        </p>
        <dl data-accordion="" class="accordion" *ngIf="hasActiveMandates()">
          <dd role="listitem" *ngFor="let mandate of mandates; last as last; index as index">
            <div class="rs-accordion-heading rs-pos-rel" role="heading" aria-level="4">
              <a
                href="javascript:void(0)"
                class="rs-flex-middle"
                role="button"
                id="ac-accordion{{ index }}"
                aria-controls="ac-accordion{{ index }}-content"
                aria-expanded="false"
              >
                <i class="rs-icon-accordion" aria-hidden="true"></i>

                <div class="rs-maxw">
                  <div class="rs-flex-row rs-flex-middle">
                    <div class="rs-flex-columns small-9 medium-5 rs-order-m1">
                      <i
                        class="icon-Expand rs-icon-accordion rs-margin-left2-neg rs-margin-right1"
                      ></i
                      >{{ mandate.description }}
                    </div>
                    <div class="rs-flex-columns small-3 medium-3 rs-order-m3"></div>
                    <div class="rs-flex-columns small-9 medium-4 rs-order-m2">
                      <span class="rs-price-s">
                        <span class="rs-nowrap"
                          ><span class="rs-euro">€</span
                          ><span class="rs-unit">{{ mandate.maxAmtPerPeriod.amount }}</span></span
                        >
                      </span>
                      <span class="rs-txt-c1 rs-font-pxR">/{{ getChargeFrequency(mandate) }}</span>
                    </div>
                  </div>
                </div>
              </a>
              <div class="rs-pos-br rs-margin-bottom2 rs-margin-bottom1-m rs-margin-right4">
                <button
                  class="rs-link-action rs-link-action-remove"
                  (click)="deleteMandate(mandate)"
                >
                  <span class="rs-link-action-label show-for-medium-up" aria-hidden="true">
                    {{ 'mpay.threshold.remove' | translate }}
                  </span>
                  <span class="rs-action-link-icon" title="Remove">
                    <span class="show-for-sr">
                      {{ 'mpay.threshold.remove' | translate }}
                    </span>
                  </span>
                </button>
              </div>
            </div>
            <div
              class="content"
              id="ac-accordion{{ index }}-content"
              role="region"
              aria-labelledby="ac-accordion{{ index }}"
            >
              <div class="row">
                <div class="small-12 medium-5 columns">
                  <p>
                    {{ 'mpay.threshold.mandates.startDate' | translate }}&nbsp;{{
                      mandate.startDate
                    }}
                  </p>
                </div>
                <div class="small-12 medium-7 columns">
                  <p>
                    {{ 'mpay.threshold.mandates.contact' | translate }}&nbsp;
                    <mprd-access-number-formatter
                      [plc]="'MV'"
                      [accessNumber]="mandate?.customerServicePhoneNr"
                    ></mprd-access-number-formatter>
                    <br />
                    {{ mandate.customerServiceEmail }}
                  </p>
                </div>
              </div>
            </div>
          </dd>
        </dl>
      </ng-container>
    </div>
  </div>
</div>
